import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { MailingTemplatePageInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-template-page.dto';
import type { MailingTemplateFindManyQueryInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-template-find-many-query.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { MailingTemplateHistoryPageInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-template-history-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MailingTemplateService extends BaseService {
  protected baseUrl = '/basis/notification/mailing/template';

  public getRegistryDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(query?: MailingTemplateFindManyQueryInterface): Observable<MailingTemplatePageInterface> {
    return this.http.get<MailingTemplatePageInterface>(`${this.baseUrl}/items`, {
      params: query ? this.objectToHttpParams(query) : {}
    });
  }

  public run(queryParams: MailingTemplateFindManyQueryInterface): Observable<null> {
    return this.http.get<null>(`${this.baseUrl}/run`, { params: this.objectToHttpParams(queryParams) });
  }

  public runById(id: number): Observable<null> {
    return this.http.get<null>(`${this.baseUrl}/${id}/run`);
  }

  public historyById(id: number, queryParams: PaginationQueryInterface): Observable<MailingTemplateHistoryPageInterface> {
    return this.http.get<MailingTemplateHistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
